<template>
  <nav
    v-if="this.$slots['default']"
    class="iconNav"
  >
    <ul class="iconNav__list">
      <slot />
    </ul>
  </nav>
</template>

<script>

export default {
  name: 'IconNav',
}

</script>

<style lang="scss" scoped>

</style>
